import { Routes } from '@angular/router';
import { ItemDetailComponent } from './pages/item-detail/item-detail.component';
import { HomeComponent } from './pages/home/home.component';
import { ProductGrid2Component } from './pages/grids/product-grid2/product-grid2.component';
import { itemResolver, itemResolverAdvance, productResolver, carouselResolver, homeDataResolver } from './shared/services/item.resolver';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ServicesComponent } from './pages/services/services.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PaymentsComponent } from './pages/payments/payments.component';
import { CartControlComponent } from './pages/cart-control/cart-control.component';
import { ProductGrid3Component } from './pages/grids/product-grid3/product-grid3.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { FilterHelpComponent } from './shared/helpScreens/filter-help/filter-help.component';
import { QuotationGenerationComponent } from './shared/helpScreens/quotation-generation/quotation-generation.component';

export const routes: Routes = [



  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    resolve: { carousel: carouselResolver, homeData: homeDataResolver }
  },

  {
    path: 'our-services',
    component: AboutUsComponent
  },
  {
    path: 'services',
    component: ServicesComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  },

  {
    path: 'payment-details',
    component: PaymentsComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },

  {
    path: 'cookie-policy',
    component: CookiePolicyComponent
  },

  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },


  {
    path: 'softnet-computers-cart',
    component: CartControlComponent
  },

  {
    path: 'help/how-to-use-filters',
    component: FilterHelpComponent
  },

  {
    path: 'help/quotation-generation',
    component: QuotationGenerationComponent
  },

  {
    path: ':cat',

    children: [

      {
        path: '',
        component: ProductGrid3Component,
        resolve: { cats: itemResolver, items: itemResolverAdvance }
      },
      {
        path: ':slug',
        component: ItemDetailComponent,
        resolve: { item: productResolver }
      }
    ]
  },

  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'home'
  }
];
